import _ from 'lodash'
import { ComponentNode, traverseComponents } from '../../traversal'
import { TagRegistry } from '../../tagRegistry'
import type { CoreExportFormat } from '@wix/document-services-types'
import { LEGACY_COMPONENT_PREFIX, LEGACY_TYPES, RESERVED_ELEMENTS } from './constants'

export const isLegacyComponent = (component: ComponentNode): boolean => {
    return !component.componentType || LEGACY_TYPES.has(component.type as string)
}

export const getComponentTypeKey = (component: ComponentNode): string | undefined => {
    if (component.componentType) {
        return component.componentType
    }
    if (!component.type) {
        return undefined
    }
    const typeStr = component.type as string
    return typeStr.startsWith(LEGACY_COMPONENT_PREFIX) ? typeStr : `${LEGACY_COMPONENT_PREFIX}${typeStr}`
}

export const createRegistryWithTypes = (componentExport: CoreExportFormat): TagRegistry => {
    const registry = new TagRegistry()
    _.forEach(RESERVED_ELEMENTS, ({ tag }, typeKey) => {
        registry.registerWithTag(typeKey, tag)
    })
    traverseComponents(componentExport, {
        onComponent: ({ component, id }) => {
            const typeKey = getComponentTypeKey(component)
            if (!typeKey) {
                throw new Error(`Component "${id}" has no componentType or type`)
            }
            if (!registry.getTagByType(typeKey)) {
                registry.register(typeKey)
            }
            registry.registerComponent(id, typeKey)
        },
    })
    return registry
}
